export default __webpack_public_path__ + "static/media/pic5.65b23c8a.jpg";